import { FOURDOOR_SOURCE } from "../../../constants/app-constants";

export const getOperationalTime = (source) => {
    if (source === FOURDOOR_SOURCE.DESKTOP) {
        return "9:30 AM - 6:30 PM";
    }
    return "9 AM - 6 PM";
};
